import { PeriodoContratoDto } from "../periodos-contrato/periodoContratoDto.model"
import { PeriodoContratoSummaryDto } from "../periodos-contrato/periodoContratoSummaryDto.model"

export class AdendarContratoRequest{
    public idContrato: number = 0
    public periodoContrato: PeriodoContratoSummaryDto[] = []
}
